function parseStringToTestId(str){
    if (str === null){
        return "";
    }
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_');
}

/* Exporting function in a legacy way so the app/org switcher still can use it */
window.parseStringToTestId = parseStringToTestId;
